import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import type { TimeZoneConfiguration } from 'hb-react/types/timeZoneConfiguration';

const useTimeZoneConfiguration = (): TimeZoneConfiguration => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();

  const eventDatesInUserTimezone =
    currentNetwork?.network_configuration?.events
      ?.display_event_dates_in_user_timezone_enabled ?? false;

  const userTimeZone =
    currentUser?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    currentUserTimezone: userTimeZone,
    eventDatesInUserTimezone,
  };
};

export default useTimeZoneConfiguration;
